import * as esriGeo from 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.js'

import { recenterMap } from '../../shared/javascripts/interactive_map/layers-init'
import { displayWeatherData } from './weather-data.js'
import { transmittersMetaData } from '../../partners/fl/javascripts/distance-transmitter'

const getLatLon = (userEnteredLocation) => {
  return new Promise((resolve, reject) => {
    esriGeo.geocode().text(userEnteredLocation).run((err, results) => {
      // Handle Network Error
      if (err) {
        reject('A network error occurred')
        return
      }
  
      // Handle scenario where geocoder cannot find a lat and lon
      if (!results.results[0]) {
        reject('Cannot find a lat/lon')
        return
      }
      // Handle scenario where lat/lon is found. We use the first result
      const { lat, lng: lon} = results.results[0].latlng
      const { Match_addr: address, City: city, RegionAbbr: state, Postal: zip } = results.results[0].properties
      const { id: stationId } = transmittersMetaData(lat, lon)

      let cityStateZip = []
      cityStateZip[0] = city
      cityStateZip[1] = state
      cityStateZip[2] = zip
      
      resolve({ lat, lon, address, cityStateZip, stationId })
    })
  })
}

/* User's location based on IP Address */
const getLocation = async () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      position => resolve(position.coords), 
      error => reject(error.message), 
      { enableHighAccuracy: false, timeout: 30000, maximumAge: 60000 * 60 * 24 })
  })
}

/* Display forecast if user gives permission to retrieve location */
const browserGeolocator = () => {
  getLocation()
  .then(location => {
    const { latitude: lat, longitude: lon } = location
    
    esriGeo.reverseGeocode().latlng([lat, lon]).run((err, result) => {
      if (err) {
        document.getElementById('user-location-mainapp').innerHTML = 'No Place Found'
        return
      }

      const { id: stationId } = transmittersMetaData(lat, lon)
      const { City: city, Region: state, Match_addr: address, Postal: zip } = result.address

      let cityStateZip = []
      cityStateZip[0] = city
      cityStateZip[1] = state
      cityStateZip[2] = zip

      // Handle scenario where user decides to type in a location but later decides
      // to use the browser geolocation to display the weather
      const location = `${city}, ${state}`
      const forecastLocation = document.getElementById('user-location-mainapp')
      const interactiveMap = document.getElementById('iradar')

      if (!forecastLocation) {
        forecastLocation.innerHTML = 'No location found'
      } else {
        forecastLocation.innerHTML = `${city}, ${state}`
      }

      if (!interactiveMap) {
        interactiveMap.innerHTML = 'Error: Interactive Map is not initializing'
      } else {
        recenterMap(lat, lon)
      }

      displayWeatherData(lat, lon, location)

      // Store lat, lon, address, and nearest affiliate locally for the user 
      localStorage.setItem('userDefaultLocation', JSON.stringify({ lat, lon, address, cityStateZip, stationId }))
    })
  })
  .catch(error => console.log(error))
}

export { getLatLon, browserGeolocator, getLocation }